import { createCn, validators } from 'cn/config'
import type { ClassValue } from 'cn'

const mergeClassNames = createCn({
  extend: {
    classGroups: {
      'bg-opacity': [{ 'bg-opacity': [validators.isAny] }],
      'border-opacity': [{ 'border-opacity': [validators.isAny] }],
      'divide-opacity': [{ 'divide-opacity': [validators.isAny] }],
      'placeholder-opacity': [{ 'placeholder-opacity': [validators.isAny] }],
      'ring-opacity': [{ 'ring-opacity': [validators.isAny] }],
      'text-opacity': [{ 'text-opacity': [validators.isAny] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return mergeClassNames(...inputs)
}
